import React from 'react'
import './index.scss'
import Pluralize from 'pluralize'
import { PreselectedMatchWork } from '@Entities/matching/preselected-match-work'

interface PreselectedWorkCardProps {
    work: PreselectedMatchWork
}

const PreselectedWorkCard = ({ work }: PreselectedWorkCardProps) => (
    <div className="preselected-work-card">
        <div className="preselected-work-card-details">
            <h5>{work.title}</h5>
            <div>
                MLC Song Code: <strong>{work.songCode}</strong>
            </div>
            <div>ISWC: {work.iswc}</div>
        </div>
        <div className="preselected-work-card-people">
            <div>
                <div className="label">
                    {Pluralize('Writer')} ({work.writerNames.length}):
                </div>
                <div>{work.writerNames.join(', ')}</div>
            </div>
            <div>
                <div className="label">
                    {Pluralize('Recording Artist')} ({work.recordingArtistNames.length}):
                </div>
                <div>{work.recordingArtistNames.join(', ')}</div>
            </div>
        </div>
        <div className="preselected-work-card-shares">
            <div className="label">Total Known Shares:</div>
            <div className="value">{work.totalKnownShares}%</div>
        </div>
    </div>
)

export default PreselectedWorkCard
